import React from 'react';
import classnames from 'classnames';
import { Link } from 'gatsby';

import { getWindowProp } from '../utils/dom';
import { FiPrinter, FiMail } from 'react-icons/fi';

import css from './Bulletins.module.css';
import grid from '../styles/grid.module.css';

const Bulletins = ({ node, list, className }) => {
	const subject = `EUROMOMO bulletin: ${node.frontmatter.title}`;
	const url = getWindowProp('location');
	const body = `This bulletin from EUROMOMO might be of your interest:%0D%0A%0D%0A${node.frontmatter.title}%0D%0A${url}`;
	return (
		<div className={classnames(grid.root, css.root, { [className]: className })}>
			<article className={classnames(css.article, grid.column6)}>
				<h1 className={css.heading}>{node.frontmatter.title}</h1>
				<div className={css.buttons}>
					<a href="#" onClick={() => window.print()}>
						<FiPrinter />
						<span>Print</span>
					</a>
					<a href={`mailto:?subject=${subject}&body=${body}`} target="_blank">
						<FiMail />
						<span>Email</span>
					</a>
				</div>
				<section className={css.content} dangerouslySetInnerHTML={{ __html: node.html }} />
			</article>
			<div className={grid.column2}>
				<aside className={css.menu}>
					<h3>Recent bulletins</h3>
					<ul>
						{list.map((n, i) => (
							<li key={i} className={classnames({ [css.active]: node.fields.slug == n.fields.slug })}>
								<Link to={n.fields.slug + '/'}>{n.frontmatter.title}</Link>
							</li>
						))}
					</ul>
				</aside>
			</div>
		</div>
	);
};

export default Bulletins;
